export default class ContactPage {
  constructor() {
    this.submitButton = document.querySelector('.co-form__submit');
    this.indicator = document.getElementsByClassName('co-stages__item')[1];

    this.activateIndicator = this.activateIndicator.bind(this);

    this.init();
  }

  init() {
    if (!this.submitButton) return;
    this.bindEvents();
  }

  bindEvents() {
    this.submitButton.addEventListener('click', this.activateIndicator);
  }

  activateIndicator() {
    this.indicator.classList.add('is-active');
  }
};